const CONFIDENCE_LABELS = {
  wysoki: 'Wysoka',
  średni: 'Średnia',
  niski: 'Niska'
}

const CONFIDENCE_SORT_RANK = {
  wysoki: 0,
  średni: 1,
  niski: 2
}

const normalizeConfidence = confidence => {
  if (confidence == null || confidence === '') {
    return null
  }
  return String(confidence).trim().toLowerCase()
}

export const formatSuggestedCourseConfidence = confidence => {
  const normalized = normalizeConfidence(confidence)
  if (!normalized) {
    return '-'
  }

  return CONFIDENCE_LABELS[normalized] || normalized
}

export const getSuggestedCourseConfidenceSortRank = confidence => {
  const normalized = normalizeConfidence(confidence)
  if (!normalized) {
    return Number.POSITIVE_INFINITY
  }

  return CONFIDENCE_SORT_RANK[normalized] ?? Number.POSITIVE_INFINITY
}

export const sortSuggestedCoursesByConfidence = (items, sortBy, sortDesc) => {
  const sortByKey = Array.isArray(sortBy) ? sortBy[0] : sortBy
  if (sortByKey !== 'confidence') {
    return items
  }

  const isDescending = Array.isArray(sortDesc) ? !!sortDesc[0] : !!sortDesc

  return items.slice().sort((a, b) => {
    const diff =
      getSuggestedCourseConfidenceSortRank(a.confidence) -
      getSuggestedCourseConfidenceSortRank(b.confidence)
    return isDescending ? -diff : diff
  })
}
